import { render, staticRenderFns } from "./isRestructuringAgingMoreThan90Days.vue?vue&type=template&id=7c8dbc48&"
import script from "./isRestructuringAgingMoreThan90Days.vue?vue&type=script&lang=js&"
export * from "./isRestructuringAgingMoreThan90Days.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports